import { useState, useEffect, useRef, useCallback } from 'react';
import { connect, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import HttpService from '../../services/httpService';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { MenuItem } from '@material-ui/core';
import moment from 'moment';
import { CSVLink } from "react-csv";
import { commaSeparateAmount } from '../../components/commaSeparate';
import { setUserDetails } from '../../redux/actions/userAction';

const useStyles = makeStyles((theme) => ({
    table: { minWidth: 700 },
    root: { width: '100%' },
    title: { fontSize: 14 },
    pos: { marginBottom: 12 },
    paper: { padding: theme.spacing(2), textAlign: 'center', color: theme.palette.text.secondary },
    header: { marginBottom: theme.spacing(2), fontWeight: "bold", textAlign: "center" },
    textField: { marginLeft: theme.spacing(1), marginRight: theme.spacing(1), width: 200 },
    tableViewButton: { backgroundColor: '#1C375D', color: '#FFF2EB', borderRadius: '20px', width: '30%', "&:hover": { backgroundColor: "#1C375D", color: '#FFF2EB' } },
    boardViewButton: { backgroundColor: '#1C375D', color: '#FFF2EB', borderRadius: '20px', width: '30%', "&:hover": { backgroundColor: "#1C375D", color: '#FFF2EB' } },
    downloadCsvButton: { backgroundColor: '#355025', color: '#FFF2EB', borderRadius: '20px', width: '30%', "&:hover": { backgroundColor: "#124a17", color: 'white' } },
    leadSearchButton: { backgroundColor: '#FDB913', color: '#151921', borderRadius: '20px', width: '20%', "&:hover": { backgroundColor: "#14419c", color: 'white' } },
    submitButton: { backgroundColor: '#F47E46 !important', color: '#FFF2EB', '&:hover': { backgroundColor: '#E0663D !important' } },
    clearButton: { backgroundColor: '#FFF2EB !important', color: '#1C375D !important', '&:hover': { backgroundColor: '#E7BAD0 !important' } },
    searchButton: { backgroundColor: '#FDB913 !important', color: '#1C375D !important', '&:hover': { backgroundColor: '#E6A411 !important' } },
}));

const StyledTableCell = withStyles((theme) => ({
    head: { backgroundColor: "#ccc", color: theme.palette.common.black },
    body: { fontSize: 14 },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: { '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } },
}))(TableRow);

const InactiveUserLeadsDashboard = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector(state => state.user);

    const [searchTypes, setSearchTypes] = useState([
        { name: 'Customer Name' }, { name: 'Email ID' }, { name: 'Lead No' },
        { name: 'Project No' }, { name: 'Contact No' }, { name: 'Unique Lead No' }
    ]);
    const [selectedSearchType, setSelectedSearchType] = useState({ name: '' });
    const [searchInput, setSearchInput] = useState("");
    const [searched, setSearched] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [totalaPages, setTotalPages] = useState(0);

    const [allTableData, setAllTableData] = useState([]);
    const [allBoardData, setAllBoardData] = useState([]);
    const [filterd, setfilterd] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [projectViewType, setProjectViewType] = useState('table');

    const buttonRef = useRef(null);

    const headers = [
        { key: "name", label: "Name" },
        { key: "lead_no", label: "Lead No" },
        { key: "uniqueLeadNumber", label: "Unique Lead No" },
        { key: "erpProjectNo", label: "Project No." },
        { key: "sourceOfLead", label: "Source Of Lead" },
        { key: "assignTo", label: "Assign To" },
        { key: "stage", label: "Stage" },
        { key: "currentStage", label: "Current Stage" },
        { key: "department", label: "Department" },
        { key: "QuotationAmount", label: "Quotation Amount" },
        { key: "createdAt", label: "Created At" },
        { key: "leadAssignedDate", label: "Lead Assigned Date" },
        { key: "expCenter", label: "Experience Center" },
        { key: "lastActivityDate", label: "Last Activity Date" },
    ];

    // ------------------ Fetch Data ------------------
    const getAllProjects = useCallback(async (newPage = page, searchType = selectedSearchType.name, searchVal = searchInput) => {
        props.setLoading(true);
        try {
            const result = await HttpService.getAllInactiveUserLeads(
                rowsPerPage,
                newPage+1,
                searchType,
                searchVal,
                userDetails.selectedExpCenter
            );

            setAllTableData(result.data.data);
            setTotalPages(result.data.pagination.total);

            const grouped = {};
            for (const item of result.data.data) {
                if (!grouped[item.currentStage]) grouped[item.currentStage] = [];
                grouped[item.currentStage].push(item);
            }

            const project = Object.entries(grouped).map(([stage, items]) => ({
                currentStage: stage,
                finalAmount: items.reduce((acc, cur) => acc + (cur.grandTotal || 0), 0),
                projects: items
            }));

            setAllBoardData(project);
        } catch (error) {
            console.error(error);
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error");
        }
        props.setLoading(false);
    }, [rowsPerPage, page, selectedSearchType, searchInput, userDetails]);

    useEffect(() => { getAllProjects(); }, [rowsPerPage, page, searchInput, userDetails]);

    // ------------------ Search ------------------
    const setHandleSearched = (value) => {
        setSearched(value);
        getAllProjects(0, selectedSearchType.name, value);
        setPage(0);
    }

    const setHandleSearchedByEnter = (e) => {
        if (e.keyCode === 13) setHandleSearched(searchInput.toUpperCase());
    }

    // ------------------ Pagination ------------------
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        // getAllProjects(newPage, selectedSearchType.name, searchInput);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRows = +event.target.value;
        setRowsPerPage(newRows);
        setPage(0);
        getAllProjects(0, selectedSearchType.name, searchInput);
    };

    // ------------------ CSV Download ------------------
    const downloadCsv = () => {
        const csvArray = allTableData.map((row) => ({
            name: row.customerName || 'NA',
            lead_no: row.lead_no || 'NA',
            uniqueLeadNumber: row.uniqueLeadNumber || 'NA',
            erpProjectNo: row.erpProjectNo || 'NA',
            sourceOfLead: row.sourceLeadName || 'NA',
            assignTo: row.assignName || 'NA',
            stage: row.stage || 'NA',
            currentStage: row.currentStage || 'NA',
            department: row.departmentName || 'NA',
            QuotationAmount: row.totalCustomerOutflow || 'NA',
            createdAt: row.createdAt ? moment(row.createdAt).format('DD-MM-YYYY') : 'NA',
            leadAssignedDate: row.leadAssignedDate ? moment(row.leadAssignedDate).format('DD-MM-YYYY') : 'NA',
            expCenter: row.experienceCenterName || 'NA',
            lastActivityDate: row.lastActivityDate ? moment(row.lastActivityDate).format('DD-MM-YYYY') : 'NA',
        }));
        setCsvData(csvArray);
        setTimeout(() => buttonRef.current.link.click());
    }

    return (
        <div>
            <div className={classes.header}><h2>Inactive User Leads Dashboard</h2></div>

            <Paper style={{ marginTop: '20px', marginBottom: "20px", padding: "20px" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: 'Auto' }}>
                    {/* Search Type */}
                    <TextField
                        select
                        value={selectedSearchType}
                        label="Search Type"
                        onChange={(e) => setSelectedSearchType(e.target.value)}
                        variant="outlined"
                        style={{ width: '30%', marginRight: '2%' }}
                        size="small"
                    >
                        {searchTypes.map((el) => (
                            <MenuItem key={el.name} value={el}>{el.name}</MenuItem>
                        ))}
                    </TextField>

                    {/* Search Input */}
                    <TextField
                        label="Enter the input"
                        size="small"
                        value={searchInput}
                        onKeyDown={setHandleSearchedByEnter}
                        onChange={(e) => setSearchInput(e.target.value)}
                        variant="outlined"
                        style={{ width: '70%' }}
                    />

                    {/* Buttons */}
                    {userDetails?.roles?.some(role => role.name !== 'Procurement Executive' && role.name !== 'Store Manager') &&
                        <>
                            <Button
                                disabled={!selectedSearchType.name || !searchInput}
                                variant="contained"
                                size="medium"
                                className={classes.searchButton}
                                style={{ marginLeft: 8 }}
                                onClick={() => setHandleSearched(searchInput.toUpperCase())}
                            >
                                Search
                            </Button>

                            <CSVLink headers={headers} filename="leadsExcel.csv" data={csvData} ref={buttonRef} />
                            <Button
                                variant="contained"
                                size="medium"
                                style={{ marginLeft: 10, backgroundColor: "#124a17", color: "#fff" }}
                                onClick={downloadCsv}
                            >
                                Download CSV
                            </Button>
                        </>
                    }
                </div>
            </Paper>

            <Paper>
                <TableContainer component={Paper}>
                    <Table className={classes.table} stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[50, 100, 250, 500, 1000, { label: 'All', value: totalaPages }]}
                                    colSpan={15}
                                    count={totalaPages}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    SelectProps={{ native: true }}
                                />
                            </TableRow>
                        </TableHead>

                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Sl No.</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Customer</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Lead No</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Unique Lead No</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Source Of Lead</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Status</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Current Stage</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Project No.</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Assigned to</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Department</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Experience Center</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Quotation Amount</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Created At</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Lead Assigned Date</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', backgroundColor: '#1C375D', color: "white", fontWeight: 'bold' }}>Last Activity Date</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>

                        <TableBody>
                            {allTableData?.map((row, i) => (
                                <StyledTableRow key={i}>
                                    <StyledTableCell component="th" >{i + 1}</StyledTableCell>
                                    <StyledTableCell component="th" >
                                        <Link target="_blank" to={`/project-logs/${row._id}`} style={{ color: "#000", textDecoration: 'underline' }}>
                                            {row.customerName}
                                        </Link>
                                    </StyledTableCell>
                                    <StyledTableCell component="th" >{row.lead_no}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.uniqueLeadNumber || 'NA'}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.sourceLeadName || 'NA'}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.status}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.currentStage}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.erpProjectNo || '-'}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.assignName}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.departmentName}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.experienceCenterName}</StyledTableCell>
                                    <StyledTableCell component="th">₹ {commaSeparateAmount(row.totalCustomerOutflow)}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.createdAt ? moment(row.createdAt).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.leadAssignedDate ? moment(row.leadAssignedDate).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                    <StyledTableCell component="th" >{row.lastActivityDate ? moment(row.lastActivityDate).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    );
}

export default connect(null, { setUserDetails, setLoading, setSnackInfo })(InactiveUserLeadsDashboard);
